import { graphql } from "@/lib/gql/__generated__";

export const DISCOUNT_LONG_TERM_FOR_LONG_TERM_STAY_CREATE_MUTATION = graphql(/* GraphQL */ `
	mutation discountLongTermForLongTermStayCreate($input: DiscountLongTermInput!) {
		discountLongTermCreate(input: $input) {
			userErrors
		}
	}
`);
